module.exports = __webpack_public_path__ + "static/offline_functionality-e0890152666fa7ab721b89e573f1f637.gif";